export default __webpack_public_path__ + "static/media/bu-odih.1d4ad029.png";